// extracted by mini-css-extract-plugin
export default {"root":"loader_root__sNtFZ","modalRoot":"loader_modalRoot__qZnli","container":"loader_container__m995n","ldsDualRing":"loader_ldsDualRing__TALD0"};